"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compositionsLoaderWithTimeout = require("@eig-builder/compositions-loader-with-timeout");

var _context = _interopRequireDefault(require("../context"));

var Provider = function Provider(_ref) {
  var children = _ref.children,
      retrieving = _ref.retrieving,
      localize = _ref.localize,
      _localizeDebug = _ref._localizeDebug;
  var _localizeProviderValue = {
    localize: localize,
    _localizeDebug: _localizeDebug
  };

  if (retrieving !== false) {
    return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
      value: _localizeProviderValue
    }, /*#__PURE__*/_react["default"].createElement(_compositionsLoaderWithTimeout.LoaderWithBackdrop, {
      centeredX: true,
      centeredY: true
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
    value: _localizeProviderValue
  }, children);
};

Provider.propTypes = {
  children: _propTypes["default"].element,
  retrieving: _propTypes["default"].bool,
  localize: _propTypes["default"].func,
  _localizeDebug: _propTypes["default"].bool
};
var _default = Provider;
exports["default"] = _default;